import { render, staticRenderFns } from "./ScrollyImage.vue?vue&type=template&id=4b32d923&"
import script from "./ScrollyImage.vue?vue&type=script&lang=js&"
export * from "./ScrollyImage.vue?vue&type=script&lang=js&"
import style0 from "./ScrollyImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports